import i18n from "@/plugins/i18n";

/* Returns the activity value in string name */
function parseActivity(value) {
  switch (value) {
    case 0:
      return i18n.t("modules.home.notConnected");
    case 1:
      return i18n.t("modules.home.connected");
    case 2:
      return i18n.t("modules.home.connectedToCloud");
    default:
      return "";
  }
}

export default {
  parseActivity
};
